import { LocalApplicationLightResult } from "./LocalApplicationLightResult";
import { LocalApplicationResult } from "./LocalApplicationResult";

export type GenericLocalApplicationResult = LocalApplicationLightResult | LocalApplicationResult;

export function mustSignCharte(application: GenericLocalApplicationResult): boolean {
  const roles = application.currentApplicationUserRolesResult?.applicationRoles || [];
  const storedUserStr = localStorage.getItem("authenticatedUser");
  if (!storedUserStr) return true;
  const chartes = JSON.parse(storedUserStr).chartes || {};
  const chartesKeys = Object.keys(chartes);
  return !(
    roles.includes("applicationManager")
    || roles.includes("userManager")
    || chartesKeys.includes(getGenericApplicationId(application))
    || chartesKeys.includes(getGenericApplicationName(application))
  );
}

export function getGenericApplicationName(application?: GenericLocalApplicationResult): string {
  return application instanceof LocalApplicationLightResult ? application.application.name : application?.name ?? "";
}

export function getGenericApplicationId(application?: GenericLocalApplicationResult): string {
  return application instanceof LocalApplicationLightResult ? application.application.id : application?.id ?? "";
}

export function getGenericApplicationConfigFile(application?: GenericLocalApplicationResult): string {
  return application instanceof LocalApplicationLightResult ? application.application.configFile : application?.configFile ?? "";
}

export function getGenericApplicationLocalName(application?: GenericLocalApplicationResult): string {
  return application instanceof LocalApplicationLightResult ? application.application.localName : application?.localName ?? "";
}
